var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-tag",staticStyle:{"position":"initial"}},_vm._l((_vm.dataList),function(item,inx){return _c('div',{key:inx,class:{
              tag: true,
              'tag-right': true,
              'tag-right-active': _vm.tagActive == (inx+1),
            },on:{"click":function($event){_vm.tagCheng((inx + 1))}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }